import ObjectUtil from './ObjectUtil'; // TODO remove and use ? operator

const get = (property) => (obj) => ObjectUtil.getChildProperty(obj, property);

const getVtoCategory = (upcMap, upcs, selectedColorId) => {
  const upcId = upcMap[selectedColorId] || upcMap[`${selectedColorId}_0`]; // strange issue on xapi side, some of upcs have _0 postfix;
  const upc = upcs[upcId];

  return get('modiFaceUPCInfo.category')(upc);
};

export const getSizes = (product) => get('traits.sizes')(product) || {};
export const getColors = (product) => get('traits.colors')(product) || {};
export const getSelectedColorId = (product) => get('traits.colors.selectedColor')(product) || null;
export const getColorMap = (product) => get('traits.colors.colorMap')(product) || {};
export const getUpcMap = (product) => get('traits.traitsMaps.upcMap')(product) || {};
export const getUpcs = (product) => get('relationships.upcs')(product) || {};
export const getUrlTemplate = (product) => get('urlTemplate')(product) || {};
export const getFlags = (product) => get('detail.flags')(product) || {};

// TODO rename to something better
export const getColorsArray = (product) => {
  const colors = getColors(product);
  return colors.orderedColorsById && colors.orderedColorsById.map((i) => ({ sizes: [], ...colors.colorMap[i] }));
};

export const getSelectedColor = (product) => {
  const selectedColorId = getSelectedColorId(product);
  return get(`traits.colors.colorMap[${selectedColorId}]`)(product) || {};
};

export const getVtoData = (product) => {
  const upcs = getUpcs(product);
  const upcMap = getUpcMap(product);
  const selectedColorId = getSelectedColorId(product);
  const category = getVtoCategory(upcMap, upcs, selectedColorId);
  const colorMap = getColorMap(product);

  return {
    upcMap,
    upcs,
    category,
    selectedColorId,
    colorMap,
    colors: getColorsArray(product),
    urlTemplate: getUrlTemplate(product),
    flags: getFlags(product),
  };
};
